import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import { environment } from 'src/environments/environment';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlingService {
  private isProduction: boolean;

  constructor(private platform: Platform) {
    this.isProduction = environment.type === 'production';
    if (this.isProduction) {
      this.initializeCrashlytics();
    }
  }

  private async initializeCrashlytics() {
    if (this.isProduction && this.platform.ANDROID) {
      try {
        await FirebaseCrashlytics.setEnabled({
          enabled: true,
        });
      } catch (error) {
        console.error('Error initializing Crashlytics:', error);
      }
    }
  }

  public async logError(error: any) {
    if (this.isProduction) {
      // Enviar error a Sentry solo en producción
      Sentry.captureException(error);

      // Enviar error a Crashlytics solo en dispositivos Android y en producción
      if (this.platform.ANDROID) {
        try {
          await FirebaseCrashlytics.recordException({
            message: this.getErrorMessage(error),
          });
        } catch (crashlyticsError) {
          console.error('Error sending to Crashlytics:', crashlyticsError);
        }
      }
    }

    // Log del error en consola (en todos los ambientes)
    if (!this.isProduction) {
      console.error('Development Error:', error);
    } else {
      console.error('Production Error:', error);
    }
  }

  private getErrorMessage(error: any): string {
    if (typeof error === 'string') {
      return error;
    }
    if (error instanceof Error) {
      return error.message;
    }
    if (error?.message) {
      return error.message;
    }
    return 'Unknown error';
  }
}
